import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { IFavicon } from "pro-features/components/Chart/src/dataLabels/favicon/Favicon";
import { Favicon } from "pro-features/components/Chart/src/dataLabels/favicon/Favicon";

const IconType = styled.div<{ offset?: string }>`
    position: absolute;
    ${({ offset = "14px" }) => `
        margin-left: ${offset};
        margin-top: ${offset};
    `};

    border-radius: 50%;
    height: 14px;
    width: 13px;
    border: 1px solid ${colorsPalettes.carbon["100"]};
    background-color: ${colorsPalettes.carbon["0"]};
`;

const SegmentIcon = styled(SWReactIcons)`
    svg {
        width: 11px;
        height: 11px;
    }
    path {
        fill: ${colorsPalettes.carbon["500"]};
    }
`;

interface Margins {
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
}

const Container = styled.div<{ margins?: Margins }>`
    align-content: center;
    .SWReactIcons svg {
        margin-top: ${(props) => props.margins?.top};
        margin-left: ${(props) => props.margins?.left};
        margin-right: ${(props) => props.margins?.right};
        margin-bottom: ${(props) => props.margins?.bottom};
    }
`;
export const SegmentFavicon: FC<IFavicon & { margins?: Margins }> = (props) => {
    const { src, margins } = props;
    return (
        <Container
            margins={{
                top: margins?.top ?? "0px",
                left: margins?.left ?? "1px",
                right: margins?.right ?? "0px",
                bottom: margins?.bottom ?? "2px",
            }}
        >
            <IconType offset={"18px"}>
                <SegmentIcon iconName="chart-pie" />
            </IconType>
            <Favicon src={src} />
        </Container>
    );
};

export const RegionalDomainsFavicon: FC<IFavicon & { margins?: Margins }> = (props) => {
    const { src, margins } = props;
    return (
        <Container
            margins={{
                top: margins?.top ?? "0px",
                left: margins?.left ?? "1px",
                right: margins?.right ?? "0px",
                bottom: margins?.bottom ?? "2px",
            }}
        >
            <IconType offset={"18px"}>
                <SegmentIcon iconName="regionals-world" />
            </IconType>
            <Favicon src={src} />
        </Container>
    );
};
